import { signal } from '@angular/core';

import { Option } from '@eiq/ui';

export class SourceVariablePreview {
  value = signal<string>('');
  constructor(
    public sourceId: string,
    public token: string,
    public options: Option<string>[]
  ) {}
}
